// extracted by mini-css-extract-plugin
module.exports = {"cardContent":"ko","bridgingOfferParagraph":"kp","bridgingOfferHeading":"kq"};